import React from 'react';
import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import { DraggableItem } from './draggable-item';

// Modified React DnD Example code below

// React DnD Draggable Item: http://react-dnd.github.io/react-dnd/docs/overview#items-and-types
export interface DraggableOption {
  id: number;
  text: string;
}

interface DnDContainerProps {
  draggableOptions: DraggableOption[];
  onMove(draggableOptions: DraggableOption[]): void;
}

export const DnDContainer: React.FC<DnDContainerProps> = ({ draggableOptions, onMove }) => {
  const [optionState, setOptions] = React.useState(draggableOptions);

  const moveItem = React.useCallback(
    (dragIndex: number, hoverIndex: number) => {
      const newState = [...optionState];
      // Remove the dragged option from the list...
      const dragItem = newState.splice(dragIndex, 1)[0];
      // And insert it after the card that's hovered over
      newState.splice(hoverIndex, 0, dragItem);
      setOptions(newState);
      onMove(newState);
    },
    [optionState]
  );

  const renderDraggableItem = (answer: DraggableOption, index: number) => {
    return <DraggableItem key={answer.id} index={index} id={answer.id} text={answer.text} moveItem={moveItem} />;
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <div>{optionState.map(renderDraggableItem)}</div>
    </DndProvider>
  );
};



// WEBPACK FOOTER //
// ./src/ui/components/drag-and-drop/drag-and-drop-container.tsx